import { render, staticRenderFns } from "./questionresult.vue?vue&type=template&id=584b5190&scoped=true&"
import script from "./questionresult.vue?vue&type=script&lang=js&"
export * from "./questionresult.vue?vue&type=script&lang=js&"
import style0 from "./questionresult.vue?vue&type=style&index=0&id=584b5190&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b5190",
  null
  
)

export default component.exports